import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import Swal from 'sweetalert2'
import router from '../../../router'
import store from '../../../store'

export default class THdata {
  constructor(){
  }
  async getTHdata(obj, api, tokenHeader){
      try {
      const countResponse = await axios.post(`${api}getTHCount`, obj, tokenHeader);
      const totalCount = countResponse.data[0].Total;

      const newValue = this.chunkArray(totalCount);
      let from = 1;
      let outputArr = [];

      for (let i = 0; i < newValue.length; i++) {
        const to = from + newValue[i] - 1;
        try {
          const res = await axios.post(`${api}thRanking/${from}/${to}`, obj, tokenHeader);
          if (res.data) {
            outputArr.push(res.data);
          }
        } catch (err) {
          if (err.response && (err.response.status === 403 || err.response.status === 401)) {
            await Swal.fire({
              icon: "info",
              title: `Token Expired System will forced logout`,
              showConfirmButton: true,
            });
            store.commit("STORE_USERINFO", null);
            store.commit("STORE_SALESOFFICE", null);
            store.commit("STORE_CHART_URL", null);
            router.push("/login");
            return;
          } else {
            throw err;
          }
        }
        from += newValue[i];
      }

      // Flatten the data
      const flattenedData = { data: outputArr.flat() };
      let plannerData =[]
      let SalesOfficeData=[]
      flattenedData.data.filter(rec=>{
          rec.year = moment(rec.SentProcessRequestDate).format('YYYY')
          rec.month = moment(rec.SentProcessRequestDate).format('MM')
          if(rec.EmployeeCode == obj.EmployeeCode){
            plannerData.push(rec)
          }
          if(rec.SalesOfficeCode == `${obj.SalesOfficeCode}`){
            SalesOfficeData.push(rec)
          }

      })
      let years = flattenedData.data.map(rec=>{
        return rec.year
      })
      let filteredYear = _.sortedUniqBy(years , Math.floor)
      let headers = filteredYear.map(yr=>{ 
          let months =  []
          flattenedData.data.map(rec=>{ 
              if(rec.year == yr){
                months.push(rec.month)
              }
          })
      let sortedMonths = _.sortedUniqBy(months , Math.floor)
          return {
          year : yr,
          months : sortedMonths
          }
      })

//==========================PLANNERS======================================================================
      let planner = plannerData.reduce((total,item)=>{
        let index = total.findIndex(y =>  y.year == item.year && y.month == item.month)
          if(index >-1){
              total[index].th += item.TH 
              total[index].kakou += 1,
              total[index].avg = Math.round(( total[index].th /  total[index].kakou)  * 10) / 10
              // total[index].avg = total[index].avg == 0  ? 0 : (total[index].avg).toFixed(1),
              total[index].item.push(item)
              return total
          }
          else{  
          total.push({
              year:item.year,
              EmployeeCode:item.EmployeeCode,
              month:item.month,
              th:item.TH,
              kakou : 1,
              avg : item.TH,
              item:[item]
          })
          return total
          }
      },[])
    
//=======================SALES OFFICE=========================================================================


let SalesOffice = SalesOfficeData.reduce((total,item)=>{
let index = total.findIndex(y =>   y.year == item.year && y.month == item.month)
if(index >-1){
    total[index].th += item.TH 
    total[index].kakou += 1,
    total[index].avg = Math.round( ( total[index].th/  total[index].kakou)  * 10) / 10
    // total[index].avg = total[index].avg == 0  ? 0 : (total[index].avg).toFixed(1),
    total[index].item.push(item)
  return total
}
else{  
  total.push(
      {
        year:item.year,
        month:item.month,
        th:item.TH,
        kakou : 1,
        avg : item.TH,
        item:[item],
      }
    )
  return total
}
},[])



SalesOffice.forEach(rec=>{
rec.ranking = rec.item.reduce((total,item)=>{
  let index = total.findIndex(y => y.EmployeeCode==item.EmployeeCode )
    if(index > -1){
        total[index].TH += item.TH
      return total
    }else{
      total.push(
        { 
        EmployeeCode:item.EmployeeCode,
        TH:item.TH,
        }
      )
      return total
    }
},[]).sort((a,b)=>{
  return a.TH - b.TH || a.EmployeeCode - b.EmployeeCode
})
})

for(let i=0; i <= SalesOffice.length-1;i++){
// console.log('------------------------',SalesOffice[i].year,SalesOffice[i].month,'-----------------------')
  for(let x=0;x <=SalesOffice[i].ranking.length-1;x++){
  // console.log(SalesOffice[i].ranking[x].EmployeeCode,SalesOffice[i].ranking[x].TH,x+1)
  if(SalesOffice[i].ranking[x].EmployeeCode == obj.EmployeeCode){
      SalesOffice[i].rank = x+1
  }
  }
}



//=======================NationWide===========================================================================

  let NationWide = flattenedData.data.reduce((total,item)=>{
    let index = total.findIndex(y =>   y.year == item.year && y.month == item.month)
    if(index >-1){
        total[index].th += item.TH 
        total[index].kakou += 1,
        total[index].avg = Math.round( ( total[index].th/  total[index].kakou)  * 10 ) / 10
        // total[index].avg = total[index].avg == 0  ? 0 : (total[index].avg).toFixed(1),
        total[index].item.push(item)
      return total
    }
    else{  
      total.push(
          {
            year:item.year,
            month:item.month,
            th:item.TH,
            kakou : 1,
            avg : item.TH,
            item:[item],
          }
        )
      return total
    }
  },[])

  NationWide.forEach(rec=>{
      rec.ranking = rec.item.reduce((total,item)=>{
        let index = total.findIndex(y => y.EmployeeCode==item.EmployeeCode )
          if(index > -1){
              total[index].TH += item.TH
            return total
          }else{
            total.push(
              { 
              EmployeeCode:item.EmployeeCode,
              TH:item.TH,
              }
            )
            return total
          }
      },[]).sort((a,b)=>{
        return a.TH - b.TH || a.EmployeeCode - b.EmployeeCode
      })
    })
    for(let i=0; i <= NationWide.length-1;i++){
        // console.log('------------------------',NationWide[i].year,NationWide[i].month,'-----------------------')
      let holdup = NationWide[i].ranking.reduce((total,item)=>{
        let index = total.findIndex(x => x.rankTH == item.TH)
          if(index > -1){
              total[index].Planners.push(item)
              return total
          }
          else{
              total.push({
                rankTH:item.TH,
                Planners:[item]
              })
              return total
          }
      },[])
      
        let ctr = 0 
        // console.log( '------'+NationWide[i].year +'--'+ NationWide[i].month +'--------')
      holdup.filter((rec,index)=>{      
        // console.log(rec)
        rec.Planners.forEach((r)=>{
          if(r.EmployeeCode == obj.EmployeeCode && index == 0){
            NationWide[i].rank = index+1
          }
          else if (r.EmployeeCode == obj.EmployeeCode && index > 0){
            NationWide[i].rank = ctr +1
          }
        })
        ctr +=  rec.Planners.length
      })
    }
    const result = {headers:headers,planner:planner,SalesOffice:SalesOffice,NationWide:NationWide}
    return result

    } catch (error) {
      console.error('Error in getTHdata:', error);
      throw error;
    }
  }
  chunkArray(value) {
    const chunkSize = 1000;
    const chunks = [];
    while (value > 0) {
        if (value >= chunkSize) {
            chunks.push(chunkSize);
            value -= chunkSize;
        } else {
            chunks.push(value);
            value = 0;
        }
    }
    return chunks;
  }
}